import { Box, Button, Stack, Typography } from "@mui/material";
import { actionFilterTabs } from "../../utils/actionFilterUtils";

const toneByKey = {
  ALL: "#6c5ce7",
  OVERDUE: "#991b1b",
  DELIVERY_RISK: "#ef4444",
  PLAN_REVIEW: "#f59e0b",
  CHANGE_REVIEW: "#8b5cf6",
};

export const OssActionFilterTabs = ({ value, counts = {}, onChange }) => (
  <Stack
    direction="row"
    spacing={0.7}
    sx={{
      flexWrap: "nowrap",
      overflowX: "auto",
      overflowY: "hidden",
      scrollbarWidth: "thin",
      pb: 0.2,
      maxWidth: "100%",
    }}
  >
    {actionFilterTabs.map((tab) => {
      const active = value === tab.key;
      const tone = toneByKey[tab.key] || "#6c5ce7";

      return (
        <Button
          key={tab.key}
          variant={active ? "contained" : "outlined"}
          onClick={() => onChange(tab.key)}
          sx={{
            minHeight: 34,
            height: 34,
            px: 1.2,
            flexShrink: 0,
            borderRadius: "999px !important",
            borderColor: active ? tone : "#e5e7eb",
            bgcolor: active ? tone : "#fff",
            color: active ? "#fff" : "#475569",
            fontSize: 12.5,
            fontWeight: "800 !important",
            "&:hover": {
              borderColor: tone,
              bgcolor: active ? tone : `${tone}0f`,
            },
          }}
        >
          <Stack direction="row" spacing={0.6} alignItems="center">
            <span>{tab.label}</span>
            <Box
              component="span"
              sx={{
                px: 0.65,
                height: 22,
                minWidth: 24,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 999,
                bgcolor: active ? "rgba(255,255,255,0.18)" : "#f1f5f9",
                border: active ? "1px solid rgba(255,255,255,0.24)" : "1px solid #e2e8f0",
              }}
            >
              <Typography component="span" sx={{ fontSize: 11.5, fontWeight: "900 !important", lineHeight: 1 }}>
                {Number(counts[tab.key] || 0).toLocaleString()}
              </Typography>
            </Box>
          </Stack>
        </Button>
      );
    })}
  </Stack>
);
